import { Model } from '@vuex-orm/core'
import { Request } from '@vuex-orm/plugin-axios'
import { getCode } from '@/lang'
import AppState from '@/utils/app.state'
import { LangedItem } from './common/commons'

export default class Fee extends Model {
  declare id: string
  declare description: LangedItem[]
  declare name: LangedItem[]

  static entity = 'fees'

  static fields() {
    return {
      id: this.attr(null),
      description: this.attr(null),
      name: this.attr(null)
    }
  }

  get friendlyName() {
    const name = this.name
    return (name && name.length && name[0].value) || ''
  }

  get friendlyDescription() {
    const desc = this.description
    return (desc && desc.length && desc[0].value) || ''
  }

  static apiConfig = {
    actions: {
      fetch(this: Request) {
        return this.post(
          '/content/v2/policies/getfeesbypropertyids',
          {
            propertyIDs: [AppState.currentProperty],
            languageCodes: [getCode()]
          }
        )
      }
    }
  }
}


